import { DeliveredWeeklyTwoByTwo } from "@dimensional-engineering/dimensional-models";

import styles from "./WeeklyTwoByTwoModal.module.css";

import SmallProfileImage from "@/components/shared/SmallProfileImage/SmallProfileImage";
import { RootState } from "@/redux/store";

export type PeerPoint = {
  authorUid: string;
  xPosition: number;
  yPosition: number;
  imageUrl: string;
  userName: string;
  publicProfile: RootState["connections"]["publicProfiles"][number];
};

export function WeeklyTwoByTwoChart(props: {
  topAxisLabel: string;
  bottomAxisLabel: string;
  leftAxisLabel: string;
  rightAxisLabel: string;
  myPoint: DeliveredWeeklyTwoByTwo;
  myImageUrl: string;
  myPublicProfile: RootState["user"]["publicProfileData"];
  peerPoints: PeerPoint[];
  fullWidth?: boolean;
  paddedInner?: boolean;
  smallText?: boolean;
  showMyPoint?: boolean;
  onMyPointClick?: () => void;
  onPeerPointClick?: (point: PeerPoint) => void;
  showPattern?: boolean;
  backgroundColor?: string;
}) {
  const topAxisLabel = capitalizeFirstLetterOnly(props.topAxisLabel);
  const bottomAxisLabel = capitalizeFirstLetterOnly(props.bottomAxisLabel);
  const leftAxisLabel = capitalizeFirstLetterOnly(props.leftAxisLabel);
  const rightAxisLabel = capitalizeFirstLetterOnly(props.rightAxisLabel);

  return (
    <div
      className={`${styles.chart} ${props.fullWidth ? styles.chartFullWidth : ""}`}
      style={{ backgroundColor: props.backgroundColor }}
    >
      {(props.showPattern ?? true) && <div className={styles.pattern}></div>}
      <div
        className={`${styles.chartInner} ${props.paddedInner ? styles.chartInnerPadded : ""}`}
      >
        <div className={styles.verticalLine}></div>
        <div className={styles.horizontalLine}></div>

        <p className={`${styles.topLabel} ${props.smallText ? styles.chartLabelSmall : ""}`}>
          {topAxisLabel}
        </p>
        <p
          className={`${styles.bottomLabel} ${props.smallText ? styles.chartLabelSmall : ""}`}
        >
          {bottomAxisLabel}
        </p>
        <p className={`${styles.leftLabel} ${props.smallText ? styles.chartLabelSmall : ""}`}>
          {leftAxisLabel}
        </p>
        <p className={`${styles.rightLabel} ${props.smallText ? styles.chartLabelSmall : ""}`}>
          {rightAxisLabel}
        </p>

        {(props.showMyPoint ?? true) && (
          <div
            style={{
              left: `calc(${mapLlmPositionToPercent(props.myPoint.xPosition)}% - 26px)`,
              bottom: `calc(${mapLlmPositionToPercent(props.myPoint.yPosition)}% - 26px)`,
            }}
            className={styles.avatarPin}
            onClick={(event) => {
              if (!props.onMyPointClick) {
                return;
              }
              event.stopPropagation();
              props.onMyPointClick();
            }}
          >
            <SmallProfileImage
              noLink
              medium
              imageUrl={props.myImageUrl}
              publicProfile={props.myPublicProfile}
            />
          </div>
        )}

        {props.peerPoints.map((point) => (
          <div
            key={point.authorUid}
            style={{
              left: `calc(${mapLlmPositionToPercent(point.xPosition)}% - 26px)`,
              bottom: `calc(${mapLlmPositionToPercent(point.yPosition)}% - 26px)`,
            }}
            className={styles.avatarPinPeer}
            onClick={(event) => {
              if (!props.onPeerPointClick) {
                return;
              }
              event.stopPropagation();
              props.onPeerPointClick(point);
            }}
          >
            <SmallProfileImage
              noLink
              medium
              imageUrl={point.imageUrl}
              publicProfile={point.publicProfile}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export function mapLlmPositionToPercent(position: number) {
  return ((position + 100) / 200) * 100;
}

function capitalizeFirstLetterOnly(label: string) {
  if (!label) {
    return label;
  }

  return `${label.charAt(0).toUpperCase()}${label.slice(1).toLowerCase()}`;
}
